function displayHandler(displayWhen: any, values: any): boolean {
  const handleFilter = (key: string) => {
    type ObjectKey = keyof typeof displayWhen;
    const myKey = key as ObjectKey;
    type ValueKey = keyof typeof values;
    const valuesKey = key as ValueKey;

    if (Array.isArray(displayWhen?.[myKey])) {
      return displayWhen?.[myKey].includes(values?.[valuesKey]);
    }

    if (typeof displayWhen[myKey] === "object") {
      return Object.keys(displayWhen[myKey]).every((key) => {
        if (Array.isArray(displayWhen?.[myKey]?.[key])) {
          return displayWhen?.[myKey]?.[key].includes(
            values?.[valuesKey]?.[key]
          );
        }
        return displayWhen?.[myKey]?.[key] === values?.[valuesKey]?.[key];
      });
    }

    return displayWhen?.[myKey] === values?.[valuesKey];
  };
  let allSame = false;
  if (!!displayWhen.anyTrue) {
    allSame = Object.keys(displayWhen).some(handleFilter)
  } else {
    allSame = Object.keys(displayWhen).every(handleFilter);
  }

  return allSame;
}

export default displayHandler;
